import { render, staticRenderFns } from "./GreetingsSuggestionButton.vue?vue&type=template&id=98749230"
import script from "./GreetingsSuggestionButton.vue?vue&type=script&lang=js"
export * from "./GreetingsSuggestionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports